import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Bot, Save, TestTube, Eye, EyeOff, CheckCircle, Plus, Edit, Trash2, Pause, Play, Clock, MessageSquare, Send, Tag, Copy, Search } from 'lucide-react';
import Layout from "../components/Layout";
import PageHeader from "../components/PageHeader";
import { useTheme } from "../contexts/ThemeContext";
import { iaAPI, fluxosAPI, tagsAPI } from "../services/api";
import FluxoVisualEditor from "../components/FluxoVisualEditor";
import WhatsAppSimulator from "../components/WhatsAppSimulator";

const AppConfig = () => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [iaConfig, setIaConfig] = useState(null);
  const [iaConfigs, setIaConfigs] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteModalID, setShowDeleteModalID] = useState(null);
  const [showPadraoModal, setShowPadraoModal] = useState(false);
  const [selectedFluxo, setSelectedFluxo] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [previewFluxo, setPreviewFluxo] = useState(null);
  const [fluxoPagina, setFluxoPagina] = useState(1);
  const [fluxoTotalPaginas, setFluxoTotalPaginas] = useState(1);
  const [fluxoTotal, setFluxoTotal] = useState(0);
  const [fluxoBusca, setFluxoBusca] = useState('');
  const [carregandoFluxo, setCarregandoFluxo] = useState(null);
  const FLUXOS_POR_PAGINA = 12;
  const [activeTab, setActiveTab] = useState("ia");
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const [showApiKey, setShowApiKey] = useState(false);
  const [testMessage, setTestMessage] = useState("");
  const [testResponse, setTestResponse] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const [chatSending, setChatSending] = useState(false);
  const chatEndRef = useRef(null);
  const [fluxos, setFluxos] = useState([]);
  const [showFluxoModal, setShowFluxoModal] = useState(false);
  const [editingFluxo, setEditingFluxo] = useState(null);
  const [allTags, setAllTags] = useState([]);
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [newTagName, setNewTagName] = useState('');
  const [newTagDesc, setNewTagDesc] = useState('');
  const [editingTagId, setEditingTagId] = useState(null);
  const [editingTag, setEditingTag] = useState({ nome: '', cor: '', descricao: '' });

  const [iaFormData, setIaFormData] = useState({
    nome: "",
    provider: "openai",
    api_key: "",
    modelo: "gpt-4o-mini",
    prompt_sistema: "",
    temperatura: 0.7,
    max_tokens: 400,
    ativo: true,
  });

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const nichos = [
    { nome: '👗 Loja de Roupas', prompt: `Você é a Ana, assistente virtual da [Nome da Loja]. Sua função é atender clientes pelo WhatsApp de forma simpática e consultiva.

SOBRE A LOJA:
- Loja de roupas femininas e masculinas
- Horário: Seg a Sex 9h-18h, Sáb 9h-13h
- Entrega para todo o Brasil via Correios e transportadora
- Troca em até 30 dias com etiqueta

COMO ATENDER:
- Sempre pergunte o que a pessoa procura (ocasião, estilo, tamanho)
- Sugira combinações de looks quando possível
- Informe preços quando perguntarem, mas sempre destaque o valor (qualidade, tecido, caimento)
- Se não souber o preço exato, diga "vou verificar com a equipe e já te retorno"
- Para finalizar compra, peça: nome completo, endereço e forma de pagamento (Pix, cartão ou boleto)

REGRAS:
- Nunca invente produtos ou preços
- Se a pessoa pedir algo que não temos, sugira alternativas
- Sempre finalize com "Posso te ajudar com mais alguma coisa?"` },
    { nome: '🏥 Clínica / Consultório', prompt: `Você é a Bia, assistente virtual da [Nome da Clínica]. Sua função é acolher pacientes e ajudar com agendamentos pelo WhatsApp.

SOBRE A CLÍNICA:
- Especialidades: clínica geral, dermatologia, ortopedia, nutrição
- Horário: Seg a Sex 8h-19h, Sáb 8h-12h
- Convênios: Unimed, Bradesco Saúde, SulAmérica, particular
- Endereço: [Rua, número, bairro, cidade]

COMO ATENDER:
- Pergunte qual especialidade a pessoa precisa
- Ofereça os horários disponíveis mais próximos
- Para agendar, peça: nome completo, CPF, convênio (ou particular) e melhor horário
- Se for retorno, pergunte o nome do médico que atendeu
- Para exames, informe os preparos necessários (jejum, etc)

REGRAS:
- NUNCA dê diagnósticos ou orientações médicas
- Se perguntarem sobre sintomas, diga "recomendo agendar uma consulta para avaliação"
- Urgências: oriente a ir ao pronto-socorro mais próximo
- Sempre confirme os dados antes de finalizar o agendamento` },
    { nome: '🍕 Restaurante / Delivery', prompt: `Você é o Léo, assistente virtual do [Nome do Restaurante]. Sua função é atender pedidos e tirar dúvidas pelo WhatsApp.

SOBRE O RESTAURANTE:
- Cozinha: [tipo de cozinha - italiana, japonesa, brasileira, etc]
- Horário: Seg a Dom 11h-23h
- Delivery: raio de 8km, taxa de entrega R$ 5-10 conforme distância
- Tempo médio de entrega: 40-60 minutos
- Pedido mínimo: R$ 30,00
- Pagamento: Pix, cartão na entrega, dinheiro (com troco)

COMO ATENDER:
- Envie o cardápio quando pedirem (ou os destaques do dia)
- Confirme cada item do pedido com quantidade e observações (sem cebola, ponto da carne, etc)
- Ao final, confirme: itens + endereço + forma de pagamento + troco se necessário
- Informe o tempo estimado de entrega

REGRAS:
- Se um item estiver indisponível, sugira alternativas similares
- Sempre repita o pedido completo antes de confirmar
- Para reclamações, peça desculpas e diga que vai encaminhar para o gerente` },
    { nome: '🏠 Imobiliária', prompt: `Você é o Carlos, assistente virtual da [Nome da Imobiliária]. Sua função é atender interessados em imóveis pelo WhatsApp.

SOBRE A IMOBILIÁRIA:
- Atuação: venda e locação de imóveis residenciais e comerciais
- Região: [cidade/bairros de atuação]
- Horário: Seg a Sex 9h-18h, Sáb 9h-13h

COMO ATENDER:
- Pergunte se a pessoa busca compra ou aluguel
- Entenda o perfil: tipo (casa/apto/sala), região preferida, quartos, faixa de preço
- Apresente opções compatíveis com o perfil
- Para visitas, ofereça horários disponíveis e peça nome e telefone
- Se perguntarem sobre financiamento, explique que trabalhamos com os principais bancos

REGRAS:
- Nunca invente imóveis ou valores
- Se não tiver imóvel no perfil, diga "vou verificar novas opções e te retorno"
- Sempre pergunte se pode agendar uma visita
- Para documentação, encaminhe para o corretor responsável` },
    { nome: '🛒 E-commerce', prompt: `Você é a Mel, assistente virtual da [Nome da Loja]. Sua função é ajudar clientes com compras, pedidos e dúvidas pelo WhatsApp.

SOBRE A LOJA:
- Produtos: [descreva os produtos que vende]
- Frete grátis acima de R$ 199
- Prazo de entrega: 3-7 dias úteis
- Troca/devolução: até 7 dias após recebimento
- Pagamento: Pix (5% desconto), cartão até 12x, boleto

COMO ATENDER:
- Se perguntarem sobre um produto, dê detalhes (descrição, preço, disponibilidade)
- Para rastrear pedido, peça o número do pedido ou CPF
- Para trocas, explique o processo e peça fotos do produto se necessário
- Sempre ofereça o link direto para compra quando possível

REGRAS:
- Nunca invente produtos, preços ou prazos
- Se o produto estiver esgotado, ofereça alternativas ou avise quando volta
- Problemas com entrega: peça o número do pedido e encaminhe para o setor de logística
- Sempre finalize perguntando se pode ajudar com mais alguma coisa` },
    { nome: '✏️ Criar do zero', prompt: '' },
  ];


  useEffect(() => {
    // Verificar query params de callback OAuth
    const success = searchParams.get('success');
    const error = searchParams.get('error');
    const platform = searchParams.get('platform');
    const selectAccount = searchParams.get('select_account');
    const accessToken = searchParams.get('access_token');
    const clienteId = searchParams.get('cliente_id');

    if (selectAccount === 'true' && accessToken) {
      // Redirecionar para página de seleção de conta
      const platformParam = searchParams.get('platform') || 'whatsapp';
      navigate(`/select-account?access_token=${encodeURIComponent(accessToken)}&cliente_id=${clienteId}&platform=${platformParam}`, { replace: true });
      return;
    }

    if (success === 'true') {
      toast.success(`Conta ${platform === 'facebook' ? 'Facebook' : platform === 'whatsapp' ? 'WhatsApp' : 'Instagram'} conectada com sucesso!`);
      navigate('/configuracoes/canais', { replace: true });
      return;
    }

    if (error) {
      toast.error(decodeURIComponent(error));
      navigate('/configuracoes/canais', { replace: true });
      return;
    }

    loadIAConfig();
    loadFluxos();
  }, []);

  // Atualiza o formulário sempre que iaConfig mudar
  useEffect(() => {
    if (iaConfig) {
      console.log("Carregando configuração da IA:", iaConfig);
      setIaFormData({
        nome: iaConfig.nome || "",
        provider: iaConfig.provider || "openai",
        api_key: iaConfig.api_key || "",
        modelo: iaConfig.modelo || "gpt-4o-mini",
        prompt_sistema: iaConfig.prompt_sistema || "",
        temperatura: iaConfig.temperatura || 0.7,
        max_tokens: iaConfig.max_tokens || 400,
        ativo: iaConfig.ativo ?? true,
      });
    } else {
      console.log(
        "Nenhuma configuração de IA encontrada, usando valores padrão"
      );
      // Reseta para valores padrão quando não há configuração
      setIaFormData({
        nome: "",
        provider: "openai",
        api_key: "",
        modelo: "gpt-4o-mini",
        prompt_sistema: "",
        temperatura: 0.7,
        max_tokens: 400,
      });
    }
  }, [iaConfig]);

  const loadIAConfig = async () => {
    try {
      const [listRes, tagsRes] = await Promise.all([
        iaAPI.listConfigs(user.cliente_id),
        tagsAPI.list(user.cliente_id),
      ]);
      setAllTags(tagsRes.data || []);
      const configs = listRes.data || [];
      setIaConfigs(configs);
      if (configs.length > 0 && !iaConfig) {
        setIaConfig(configs[0]);
        setSelectedTagIds(configs[0].tags_ia || []);
      }
    } catch (error) {
      console.log("Nenhuma configuração de IA encontrada");
      setIaConfig(null);
      setIaConfigs([]);
    }
  };

  const loadFluxos = async (pagina = fluxoPagina, busca = fluxoBusca) => {
    try {
      const response = await fluxosAPI.list(user.cliente_id, {
        page: pagina,
        limit: FLUXOS_POR_PAGINA,
        search: busca,
      });
      const corpo = response.data || {};
      const lista = corpo.data || (Array.isArray(corpo) ? corpo : []);
      const paginas = corpo.totalPages ?? 1;
      setFluxoTotal(corpo.total ?? 0);
      setFluxoTotalPaginas(paginas);
      // Apagar o último item de uma página deixava a lista vazia com o contador
      // cheio e sem controles para voltar.
      if (lista.length === 0 && pagina > paginas) {
        setFluxoPagina(paginas);
        return;
      }
      setFluxos(lista);
    } catch (error) {
      console.log("Erro ao carregar fluxos:", error);
      setFluxos([]);
    }
  };

  // Busca reseta para a primeira pagina; 500ms e o mesmo debounce de Contatos.
  useEffect(() => {
    if (activeTab !== 'fluxos') return;
    const t = setTimeout(() => {
      setFluxoPagina(1);
      loadFluxos(1, fluxoBusca);
    }, 500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fluxoBusca, activeTab]);

  useEffect(() => {
    if (activeTab === 'fluxos') loadFluxos(fluxoPagina, fluxoBusca);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fluxoPagina]);

  const handleIASubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      // Limpar e converter tipos
      // provider, modelo e api_key são configurados pelo ADM (nível admin),
      // não por esta tela — o backend descarta se vierem daqui.
      const payload = {
        nome: iaFormData.nome,
        prompt_sistema: iaFormData.prompt_sistema,
        temperatura: Number(iaFormData.temperatura),
        max_tokens: Number(iaFormData.max_tokens),
        tags_ia: selectedTagIds,
      };

      const configData = {
        ...payload,
        cliente_id: user.cliente_id,
        usuario_id: user.id,
      };

      if (iaConfig) {
        await iaAPI.updateConfig(iaConfig.id, payload);
        toast.success("Configuração de IA atualizada com sucesso!");
      } else {
        await iaAPI.createConfig(configData);
        toast.success("Configuração de IA criada com sucesso!");
      }

      await loadIAConfig();
    } catch (error) {
      console.error('❌ Erro ao salvar:', error);
      toast.error(
        error.response?.data?.message || "Erro ao salvar configuração de IA"
      );
    } finally {
      setSaving(false);
    }
  };

  const handleTestIA = async () => {
    if (!testMessage.trim()) {
      toast.error("Digite uma mensagem para testar");
      return;
    }

    setTesting(true);
    setTestResponse("");

    try {
      if (!iaFormData.prompt_sistema.trim()) {
        toast.error("Configure o prompt do sistema antes de testar");
        setTesting(false);
        return;
      }

      const response = await iaAPI.testResponse(user.cliente_id, {
        mensagem: testMessage,
        contexto: "Teste da configuração da IA",
        prompt_sistema: iaFormData.prompt_sistema,
      });

      setTestResponse(response.data.resposta || "Nenhuma resposta gerada");
      toast.success("Teste realizado com sucesso!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Erro ao testar IA");
      setTestResponse(
        "Erro: " +
          (error.response?.data?.message || "Falha na comunicação com a IA")
      );
    } finally {
      setTesting(false);
    }
  };

  useEffect(() => { if (chatMessages.length) chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [chatMessages]);

  const handleChatSend = async () => {
    if (!testMessage.trim() || !iaConfig || chatSending) return;
    const msg = testMessage.trim();
    setTestMessage('');
    setChatMessages(prev => [...prev, { from: 'user', text: msg }]);
    setChatSending(true);
    // Placeholder "digitando"
    setChatMessages(prev => [...prev, { from: 'bot', text: '', loading: true }]);
    try {
      const contexto = chatMessages.filter(m => !m.loading).map(m => `${m.from === 'user' ? 'Cliente' : 'Assistente'}: ${m.text}`).join('\n');
      const res = await iaAPI.testResponse(user.cliente_id, { mensagem: msg, contexto, prompt_sistema: iaFormData.prompt_sistema });
      const resposta = res.data.resposta || 'Sem resposta';
      setChatMessages(prev => prev.map((m, i) => i === prev.length - 1 ? { from: 'bot', text: resposta } : m));
    } catch {
      setChatMessages(prev => prev.map((m, i) => i === prev.length - 1 ? { from: 'bot', text: '❌ Erro ao gerar resposta' } : m));
    } finally {
      setChatSending(false);
    }
  };

  const handleFluxoSave = async (fluxoData) => {
    try {
      const dataWithUser = {
        ...fluxoData,
        usuario_id: user.id,
      };

      if (editingFluxo) {
        await fluxosAPI.update(editingFluxo.id, fluxoData);
        toast.success("Fluxo atualizado com sucesso!");
      } else {
        await fluxosAPI.create(user.cliente_id, dataWithUser);
        toast.success("Fluxo criado com sucesso!");
      }

      setShowFluxoModal(false);
      setEditingFluxo(null);
      loadFluxos();
    } catch (error) {
      toast.error(
        "Erro ao salvar fluxo: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  // A lista devolve etapas_count, nao o array de etapas — e o GET /:id ainda
  // resolve as URLs de midia (`s3://` -> assinada), o que a lista nunca fez.
  // Busca antes de abrir: o modal montado sem o fluxo mostraria a tela de
  // templates por um instante antes de trocar pelo canvas.
  const abrindoFluxoRef = useRef(0);

  const abrirFluxoCompleto = async (fluxo, aplicar, abrir) => {
    // Sem este selo, clicar Editar num link lento e depois "Novo Fluxo" fazia a
    // resposta atrasada reapontar o editor para o fluxo antigo — e o Salvar
    // sobrescrevia ele em vez de criar o novo.
    const selo = ++abrindoFluxoRef.current;
    setCarregandoFluxo(fluxo.id);
    try {
      const res = await fluxosAPI.get(fluxo.id);
      if (selo !== abrindoFluxoRef.current) return;
      aplicar(res.data?.data || res.data || fluxo);
      abrir(true);
    } catch (error) {
      if (selo !== abrindoFluxoRef.current) return;
      console.error('Erro ao carregar fluxo:', error);
      toast.error('Não foi possível carregar o fluxo');
    } finally {
      if (selo === abrindoFluxoRef.current) setCarregandoFluxo(null);
    }
  };

  const handleEditFluxo = (fluxo) => {
    abrirFluxoCompleto(fluxo, setEditingFluxo, setShowFluxoModal);
  };

  const handleTogglePadrao = async () => {
    try {
      await fluxosAPI.update(selectedFluxo.id, { padrao: !selectedFluxo.padrao });
      toast.success(selectedFluxo.padrao ? "Fluxo desmarcado como padrão" : "Fluxo marcado como padrão");
      loadFluxos();
      setShowPadraoModal(false);
      setSelectedFluxo(null);
    } catch (error) {
      toast.error("Erro ao atualizar fluxo");
    }
  };

  const handleToggleAtivo = async (fluxo) => {
    try {
      await fluxosAPI.update(fluxo.id, { ativo: !fluxo.ativo });
      toast.success(fluxo.ativo ? "Fluxo desativado" : "Fluxo ativado");
      loadFluxos();
    } catch (error) {
      toast.error("Erro ao atualizar fluxo");
    }
  };

  const handleDelete = (id) => {  
    setShowDeleteModal(true)
    setShowDeleteModalID(id)
}

  const handleModalDelete  = async () => {
      try {
        await fluxosAPI.delete(showDeleteModalID);
        toast.success("Fluxo excluído com sucesso!");
        loadFluxos();
      } catch (error) {
        toast.error("Erro ao excluir fluxo");
      }
        setShowDeleteModal(false)
  };

  const handlePreviewFluxo = (fluxo) => {
    abrirFluxoCompleto(fluxo, setPreviewFluxo, setShowPreview);
  };

  const criarFluxoExemplo = async () => {
    const fluxoExemplo = {
      nome: "Atendimento Moderno",
      descricao: "Fluxo otimizado com nova interface",
      ativo: true,
      etapas: [
        {
          nome: "Saudação",
          tipo_etapa: "mensagem",
          mensagem_automatica:
            "Olá! 👋 Bem-vindo à nossa empresa!\n\n\nComo posso ajudá-lo hoje?",
          aguardar_resposta: false,
        },
        {
          nome: "Menu Principal",
          tipo_etapa: "menu",
          mensagem_automatica:
            "Escolha uma das opções:\n\n1️⃣ Vendas\n2️⃣ Suporte Técnico\n3️⃣ Financeiro\n\nDigite o número da opção:",
          opcoes_menu: [
            { opcao: "1", texto: "Vendas" },
            { opcao: "2", texto: "Suporte" },
            { opcao: "3", texto: "Financeiro" },
          ],
        },
        {
          nome: "Transferência",
          tipo_etapa: "aguardar",
          mensagem_automatica:
            "Perfeito! ✅\n\n\nEm breve um de nossos especialistas entrará em contato.\n\n\nAguarde um momento...",
        },
      ],
    };

    try {
      await handleFluxoSave(fluxoExemplo);
    } catch (error) {
      console.error("Erro ao criar fluxo exemplo:", error);
    }
  };

  const card = `rounded-xl p-5 ${darkMode ? 'bg-zinc-800 border border-zinc-700' : 'bg-white border border-gray-200'}`;
  const textP = darkMode ? 'text-white' : 'text-gray-900';
  const textS = darkMode ? 'text-gray-400' : 'text-gray-500';
  const inputCls = `w-full rounded-lg py-2 px-3 text-sm ${darkMode ? 'bg-zinc-700 border-zinc-600 text-white' : 'bg-white border-gray-300 text-gray-900'} border focus:outline-none focus:ring-1 focus:ring-nomoz-orange`;

  return (
    <Layout>
      <div className="space-y-6">
        <PageHeader title="Nomoz Agent" subtitle="Configure IA e fluxos de atendimento automático" />

        {/* Tabs */}
        <div className="flex flex-col sm:flex-row gap-2">
          {[
            { id: 'ia', label: 'Nomoz Agent 2.0', icon: Bot, desc: 'IA Generativa' },
            { id: 'fluxos', label: 'Nomoz Agent 1.0', icon: MessageSquare, desc: 'Fluxos' },
          ].map(tab => (
            <button key={tab.id} onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-3 px-5 py-3 rounded-xl text-sm font-medium transition-all ${
                activeTab === tab.id
                  ? 'bg-nomoz-navy text-white shadow-lg shadow-blue-900/20'
                  : darkMode ? 'bg-zinc-800 text-gray-400 hover:bg-zinc-700' : 'bg-white text-gray-600 hover:bg-gray-50 border border-gray-200'
              }`}>
              <tab.icon className="h-4 w-4" />
              <div className="text-left">
                <div>{tab.label}</div>
                <div className={`text-xs ${activeTab === tab.id ? 'text-green-100' : textS}`}>{tab.desc}</div>
              </div>
            </button>
          ))}
        </div>
        {activeTab === "ia" && (
          <div className="space-y-6">
            {/* Lista de agentes */}
            <div className={`${card}`}>
              <div className="flex items-center justify-between mb-4">
                <h3 className={`font-semibold ${textP}`}>Agentes de IA</h3>
                <button
                  onClick={async () => {
                    try {
                      const res = await iaAPI.createConfig({ cliente_id: user.cliente_id, usuario_id: user.id, nome: 'Novo Agente', provider: 'openai', modelo: 'gpt-4o-mini', prompt_sistema: 'Você é um assistente virtual.', temperatura: 0.7, max_tokens: 400, ativo: true });
                      toast.success('Agente criado');
                      await loadIAConfig();
                      setIaConfig(res.data);
                    } catch { toast.error('Erro ao criar agente'); }
                  }}
                  className="flex items-center gap-2 px-3 py-1.5 bg-green-600 hover:bg-green-700 text-white text-sm rounded-lg font-medium transition-colors"
                >
                  <Plus className="h-4 w-4" /> Novo agente
                </button>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {iaConfigs.map(config => (
                  <div
                    key={config.id}
                    onClick={() => { setIaConfig(config); setSelectedTagIds(config.tags_ia || []); }}
                    className={`p-4 rounded-xl cursor-pointer transition-all border-2 ${
                      iaConfig?.id === config.id
                        ? 'border-green-500 ' + (darkMode ? 'bg-green-900/20' : 'bg-green-50')
                        : (darkMode ? 'border-zinc-700 bg-zinc-800 hover:border-zinc-600' : 'border-gray-200 bg-white hover:border-gray-300')
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <div className={`h-10 w-10 rounded-lg flex items-center justify-center bg-green-500/20`}>
                        <Bot className="h-5 w-5 text-green-500" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className={`font-medium truncate ${textP}`}>{config.nome || 'Sem nome'}</h4>
                      </div>
                    </div>
                  </div>
                ))}
                {iaConfigs.length === 0 && (
                  <p className={`text-sm col-span-full text-center py-4 ${textS}`}>Nenhum agente configurado</p>
                )}
              </div>
            </div>

            {/* Layout focado na experiência */}
            <div className="max-w-7xl mx-auto space-y-8">
              {/* Hero: Escolha seu assistente */}
              <div className="text-center space-y-3">
                <h2 className={`text-2xl font-bold ${textP}`}>Monte seu assistente virtual</h2>
                <p className={`text-base ${textS}`}>Escolha um modelo pronto ou crie do zero. Teste em tempo real.</p>
              </div>

              {/* Nichos como cards grandes */}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {nichos.map(n => (
                  <button key={n.nome} onClick={() => setIaFormData({ ...iaFormData, prompt_sistema: n.prompt, nome: n.prompt ? n.nome.replace(/^[^\s]+\s/, 'Assistente ') : iaFormData.nome })}
                    className={`group relative p-6 rounded-2xl text-center transition-all ${
                      iaFormData.prompt_sistema === n.prompt && n.prompt
                        ? 'bg-gradient-to-br from-blue-600 to-blue-800 text-white shadow-2xl scale-105'
                        : darkMode ? 'bg-zinc-800 hover:bg-zinc-700 text-gray-300' : 'bg-white hover:shadow-xl border-2 border-gray-200 hover:border-green-400 text-gray-700'
                    }`}>
                    <div className="text-4xl mb-3">{n.nome.split(' ')[0]}</div>
                    <p className="text-sm font-medium">{n.nome.replace(/^[^\s]+\s/, '')}</p>
                    {iaFormData.prompt_sistema === n.prompt && n.prompt && (
                      <div className="absolute -top-2 -right-2 h-6 w-6 bg-white rounded-full flex items-center justify-center shadow-lg">
                        <div className="h-3 w-3 bg-green-500 rounded-full"></div>
                      </div>
                    )}
                  </button>
                ))}
              </div>

              {/* Form GRANDE + Chat preview lateral */}
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* Form protagonista - 2 colunas */}
                <div className={`lg:col-span-2 ${card}`}>
                  <h3 className={`text-xl font-bold mb-6 ${textP}`}>✨ Configure seu assistente</h3>
                  <form onSubmit={handleIASubmit} className="space-y-6">
                    <div>
                      <label className={`block text-base font-semibold mb-3 ${textP}`}>Nome do assistente</label>
                      <input type="text" required className={`${inputCls} text-base`} value={iaFormData.nome}
                        onChange={e => setIaFormData({ ...iaFormData, nome: e.target.value })}
                        placeholder="Ex: Assistente da Loja" />
                    </div>

                    <div>
                      <label className={`block text-base font-semibold mb-3 ${textP}`}>Instruções detalhadas</label>
                      <textarea required className={`${inputCls} text-sm leading-relaxed`} rows={20} value={iaFormData.prompt_sistema}
                        onChange={e => setIaFormData({ ...iaFormData, prompt_sistema: e.target.value })}
                        placeholder="Descreva sua empresa, produtos, horários, regras de atendimento...

Exemplo:
- Nome da empresa
- O que você vende/oferece
- Horários de funcionamento
- Formas de pagamento
- Políticas de troca/devolução
- Como a IA deve se comportar" />
                      <p className={`mt-3 text-sm ${textS}`}>
                        💡 Quanto mais detalhes você fornecer, melhor será o atendimento automático
                      </p>
                    </div>

                    {/* Tags de triagem */}
                    <div className={`rounded-xl p-4 ${darkMode ? 'bg-zinc-800 border border-zinc-700' : 'bg-gray-50 border border-gray-200'}`}>
                      <label className={`flex items-center gap-2 text-sm font-semibold mb-2 ${textP}`}>
                        <Tag className="h-4 w-4" />
                        Tags de triagem da IA
                      </label>
                      <p className={`text-xs mb-3 ${textS}`}>Selecione quais tags a IA pode usar. Clique no lápis para editar nome, cor e descrição.</p>
                      <div className={`space-y-1 max-h-64 overflow-y-auto rounded-lg p-2 ${darkMode ? 'bg-zinc-900' : 'bg-white border border-gray-100'}`}>
                        {allTags.map(tag => (
                          <div key={tag.id}>
                            {editingTagId === tag.id ? (
                              <div className={`p-2 rounded-lg border ${darkMode ? 'border-zinc-600 bg-zinc-800' : 'border-blue-200 bg-blue-50'}`}>
                                <div className="flex gap-2 mb-2">
                                  <input type="color" value={editingTag.cor} onChange={e => setEditingTag({...editingTag, cor: e.target.value})} className="w-10 h-8 rounded cursor-pointer border-0" />
                                  <input type="text" value={editingTag.nome} onChange={e => setEditingTag({...editingTag, nome: e.target.value})} placeholder="Nome"
                                    className={`flex-1 text-sm border rounded px-2 py-1 ${darkMode ? 'bg-zinc-700 border-zinc-600 text-white' : 'border-gray-300'}`} />
                                </div>
                                <input type="text" value={editingTag.descricao} onChange={e => setEditingTag({...editingTag, descricao: e.target.value})} placeholder="Descrição (quando a IA deve usar esta tag)"
                                  className={`w-full text-xs border rounded px-2 py-1 mb-2 ${darkMode ? 'bg-zinc-700 border-zinc-600 text-white' : 'border-gray-300'}`} />
                                <div className="flex gap-2">
                                  <button type="button" onClick={async () => {
                                    try {
                                      await tagsAPI.update(tag.id, editingTag);
                                      setAllTags(prev => prev.map(t => t.id === tag.id ? {...t, ...editingTag} : t));
                                      setEditingTagId(null);
                                      toast.success('Tag atualizada!');
                                    } catch { toast.error('Erro ao atualizar'); }
                                  }} className="px-3 py-1 bg-green-600 text-white rounded text-xs hover:bg-green-700">Salvar</button>
                                  <button type="button" onClick={() => setEditingTagId(null)} className="px-3 py-1 bg-gray-500 text-white rounded text-xs hover:bg-gray-600">Cancelar</button>
                                </div>
                              </div>
                            ) : (
                              <div className={`flex items-center gap-3 p-2 rounded-lg transition ${darkMode ? 'hover:bg-zinc-800' : 'hover:bg-gray-50'}`}>
                                <input type="checkbox" checked={selectedTagIds.includes(tag.id)}
                                  onChange={() => setSelectedTagIds(prev => prev.includes(tag.id) ? prev.filter(id => id !== tag.id) : [...prev, tag.id])}
                                  className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                                <span className="w-4 h-4 rounded-full shrink-0 border border-white/20" style={{ backgroundColor: tag.cor }} />
                                <span className={`text-sm font-medium flex-1 ${textP}`}>{tag.nome}</span>
                                {tag.descricao && <span className={`text-xs max-w-[200px] truncate ${textS}`}>{tag.descricao}</span>}
                                <button type="button" onClick={() => { setEditingTagId(tag.id); setEditingTag({ nome: tag.nome, cor: tag.cor, descricao: tag.descricao || '' }); }}
                                  className={`p-1 rounded ${darkMode ? 'hover:bg-zinc-700 text-zinc-400' : 'hover:bg-gray-200 text-gray-400'}`}>
                                  <Edit className="h-3.5 w-3.5" />
                                </button>
                              </div>
                            )}
                          </div>
                        ))}
                        {allTags.length === 0 && <p className={`text-xs text-center py-3 ${textS}`}>Nenhuma tag criada ainda</p>}
                      </div>
                      {/* Criar nova tag */}
                      <div className={`mt-3 p-3 rounded-lg border ${darkMode ? 'border-zinc-700 bg-zinc-800' : 'border-gray-200 bg-gray-50'}`}>
                        <div className="flex gap-2 mb-2">
                          <input type="color" value={newTagDesc || '#3b82f6'} onChange={e => setNewTagDesc(e.target.value)} className="w-10 h-8 rounded cursor-pointer border-0" />
                          <input type="text" placeholder="Nome da nova tag" value={newTagName} onChange={e => setNewTagName(e.target.value)}
                            className={`flex-1 text-sm border rounded-lg px-3 py-1.5 ${darkMode ? 'bg-zinc-700 border-zinc-600 text-white' : 'border-gray-300'}`} />
                          <button type="button" disabled={!newTagName.trim()} onClick={async () => {
                            try {
                              const res = await tagsAPI.create({ cliente_id: user.cliente_id, nome: newTagName.trim(), cor: newTagDesc || '#3b82f6' });
                              setAllTags(prev => [...prev, res.data]);
                              setSelectedTagIds(prev => [...prev, res.data.id]);
                              setNewTagName(''); setNewTagDesc('');
                              toast.success('Tag criada!');
                            } catch { toast.error('Erro ao criar tag'); }
                          }} className="px-4 py-1.5 bg-blue-600 text-white rounded-lg text-sm disabled:opacity-50 hover:bg-blue-700 flex items-center gap-1">
                            <Plus className="h-4 w-4" /> Criar
                          </button>
                        </div>
                      </div>
                    </div>

                    <button type="submit" disabled={saving}
                      className="w-full inline-flex items-center justify-center px-6 py-4 text-lg font-bold rounded-xl text-white disabled:opacity-50 shadow-lg hover:shadow-xl transition-all bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900">
                      {saving ? (
                        <>
                          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2" />
                          Salvando...
                        </>
                      ) : iaConfig ? (
                        <>
                          <Save className="h-6 w-6 mr-2" />
                          Salvar Alterações
                        </>
                      ) : (
                        <>
                          ✨ Criar Assistente
                        </>
                      )}
                    </button>
                  </form>
                </div>

                {/* Chat preview lateral - 1 coluna */}
                <div className="space-y-4">
                  <h3 className={`text-base font-semibold ${textP}`}>💬 Testar agora</h3>
                  <div className={`rounded-xl overflow-hidden border ${darkMode ? 'border-zinc-700' : 'border-gray-300'} shadow-lg`}>
                    {/* WhatsApp header */}
                    <div className="bg-[#075E54] px-3 py-2 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="h-8 w-8 rounded-full bg-white/20 flex items-center justify-center">
                          <Bot className="h-4 w-4 text-white" />
                        </div>
                        <div>
                          <p className="text-white text-xs font-medium">{iaFormData.nome || 'Assistente'}</p>
                          <p className="text-green-200 text-[10px]">{iaConfig ? '🟢 online' : '⚫ offline'}</p>
                        </div>
                      </div>
                      {chatMessages.length > 0 && (
                        <button onClick={() => setChatMessages([])} className="text-white/80 hover:text-white text-[10px] font-medium">
                          Limpar
                        </button>
                      )}
                    </div>

                    {/* Chat area */}
                    <div className="h-[350px] overflow-y-auto p-4 space-y-2" style={{ background: darkMode ? '#1a1a2e' : '#ECE5DD' }}>
                      {chatMessages.length === 0 && (
                        <div className="flex flex-col items-center justify-center h-full space-y-3">
                          <div className="text-4xl">💬</div>
                          <p className={`text-sm text-center font-medium ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                            {iaConfig ? 'Teste seu assistente' : 'Salve primeiro'}
                          </p>
                        </div>
                      )}
                      {chatMessages.map((msg, i) => (
                        <div key={i} className={`flex ${msg.from === 'user' ? 'justify-end' : 'justify-start'}`}>
                          <div className={`max-w-[85%] px-3 py-2 rounded-lg text-xs whitespace-pre-wrap ${
                            msg.from === 'user'
                              ? 'bg-[#DCF8C6] text-gray-900 rounded-tr-none'
                              : darkMode ? 'bg-zinc-700 text-gray-200 rounded-tl-none' : 'bg-white text-gray-900 rounded-tl-none shadow-sm'
                          }`}>
                            {msg.text}
                            {msg.loading && <span className="inline-block ml-1 animate-pulse">...</span>}
                          </div>
                        </div>
                      ))}
                      <div ref={chatEndRef} />
                    </div>

                    {/* Input */}
                    <div className={`p-2 flex gap-2 ${darkMode ? 'bg-zinc-800' : 'bg-[#F0F0F0]'}`}>
                      <input type="text" className={`flex-1 rounded-full px-3 py-2 text-xs ${
                        darkMode ? 'bg-zinc-700 text-white border-0' : 'bg-white text-gray-900 border-0'
                      } focus:outline-none focus:ring-2 focus:ring-nomoz-orange`}
                        value={testMessage} onChange={e => setTestMessage(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && !e.shiftKey && handleChatSend()}
                        placeholder={iaConfig ? 'Teste aqui...' : 'Salve primeiro'}
                        disabled={!iaConfig || chatSending} />
                      <button onClick={handleChatSend} disabled={!iaConfig || chatSending || !testMessage.trim()}
                        className="h-8 w-8 rounded-full bg-[#075E54] flex items-center justify-center disabled:opacity-40 hover:bg-[#064e45] transition-all">
                        <Send className="h-4 w-4 text-white" />
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        )}

        {activeTab === "fluxos" && (
          <div className="space-y-5">
            {/* Header */}
            <div className={`flex justify-between items-center p-4 rounded-xl ${darkMode ? 'bg-zinc-800 border border-zinc-700' : 'bg-white border border-gray-200'}`}>
              <div>
                <h3 className={`text-sm font-medium ${textP}`}>Fluxos de Conversa</h3>
                <p className={`text-xs ${textS}`}>
                  {fluxoTotal > 0
                    ? `${fluxoTotal} fluxo${fluxoTotal > 1 ? 's' : ''}`
                    : 'Configure fluxos estruturados de atendimento'}
                </p>
              </div>
              <div className="flex gap-2 items-center">
                <div className="relative">
                  <Search className={`absolute left-2.5 top-2.5 h-4 w-4 ${textS}`} />
                  <input
                    type="text"
                    value={fluxoBusca}
                    onChange={(e) => setFluxoBusca(e.target.value)}
                    placeholder="Buscar fluxo..."
                    className={`pl-8 pr-3 py-2 text-sm rounded-lg border w-40 sm:w-56 ${
                      darkMode
                        ? 'bg-zinc-900 border-zinc-700 text-gray-200 placeholder-gray-500'
                        : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'
                    }`}
                  />
                </div>
                <button onClick={() => criarFluxoExemplo()}
                  className={`inline-flex items-center px-3 py-2 text-sm rounded-lg ${darkMode ? 'bg-zinc-700 text-gray-300 hover:bg-zinc-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
                  <Bot className="h-4 w-4 mr-2" />Exemplo
                </button>
                <button onClick={() => {
                    abrindoFluxoRef.current++;
                    setCarregandoFluxo(null);
                    setEditingFluxo(null);
                    setShowFluxoModal(true);
                  }}
                  className="gradient-button inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg text-white">
                  <Plus className="h-4 w-4 mr-2" />Novo Fluxo
                </button>
              </div>
            </div>
            {/* Fluxos List */}
            <div className={`${darkMode ? 'bg-zinc-800 border border-zinc-700' : 'bg-white border border-gray-200'} rounded-xl overflow-hidden`}>
              {fluxos.length === 0 ? (
                <div className={`px-6 py-8 text-center ${textS}`}>
                  <Bot className={`mx-auto h-12 w-12 ${textS} mb-4`} />
                  <h3 className={`text-sm font-medium ${textP}`}>
                    {fluxoBusca ? 'Nenhum fluxo encontrado' : 'Nenhum fluxo configurado'}
                  </h3>
                  <p className={`text-sm ${textS}`}>Comece criando um novo fluxo de conversa.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-6">
                  {Array.isArray(fluxos) && fluxos.map((fluxo) => (
                    <div key={fluxo.id}
                      className={`relative rounded-xl shadow-lg overflow-hidden transition-all hover:shadow-xl ${
                        darkMode ? "bg-zinc-800" : "bg-white"
                            }`}
                          >
                            {/* Badge Padrão no Canto */}
                            {fluxo.padrao && (
                              <div className="absolute top-0 right-0">
                                <div className="bg-green-500 text-white text-xs font-bold px-4 py-1 rounded-bl-lg">
                                  PADRÃO
                                </div>
                              </div>
                            )}

                            {/* Header */}
                            <div className={`p-6 ${
                              fluxo.padrao 
                                ? "bg-gradient-to-r from-blue-600 to-blue-800" 
                                : "bg-gradient-to-r from-blue-500 to-blue-600"
                            }`}>
                              <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-4">
                                  <div className="h-14 w-14 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                                    <Bot className="h-8 w-8 text-white" />
                                  </div>
                                  <div>
                                    <h3 className="text-xl font-bold text-white">
                                      {fluxo.nome}
                                    </h3>
                                    <div className="flex items-center gap-2 mt-1">
                                      <button
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleToggleAtivo(fluxo);
                                        }}
                                        className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium cursor-pointer transition-colors ${
                                          fluxo.ativo
                                            ? "bg-white/30 text-white hover:bg-white/40"
                                            : "bg-red-500/80 text-white hover:bg-red-600/80"
                                        }`}
                                        title={fluxo.ativo ? "Clique para desativar" : "Clique para ativar"}
                                      >
                                        {fluxo.ativo ? (
                                          <>
                                            <Play className="h-3 w-3 mr-1" />
                                            Ativo
                                          </>
                                        ) : (
                                          <>
                                            <Pause className="h-3 w-3 mr-1" />
                                            Inativo
                                          </>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Body */}
                            <div className="p-6">
                              {/* Descrição */}
                              {fluxo.descricao ? (
                                <p className={`text-sm mb-4 ${
                                  darkMode ? "text-gray-300" : "text-gray-600"
                                }`}>
                                  {fluxo.descricao}
                                </p>
                              ) : (
                                <p className={`text-sm mb-4 italic ${
                                  darkMode ? "text-gray-500" : "text-gray-400"
                                }`}>
                                  Sem descrição
                                </p>
                              )}

                              {/* Stats */}
                              <div className="grid grid-cols-2 gap-4 mb-6">
                                <div className={`p-3 rounded-lg ${
                                  darkMode ? "bg-zinc-700" : "bg-gray-50"
                                }`}>
                                  <div className="flex items-center gap-2">
                                    <MessageSquare className={`h-4 w-4 ${
                                      darkMode ? "text-blue-400" : "text-blue-500"
                                    }`} />
                                    <span className={`text-xs font-medium ${
                                      darkMode ? "text-gray-400" : "text-gray-500"
                                    }`}>
                                      Etapas
                                    </span>
                                  </div>
                                  <p className={`text-2xl font-bold mt-1 ${
                                    darkMode ? "text-white" : "text-gray-900"
                                  }`}>
                                    {fluxo.etapas_count ?? fluxo.etapas?.length ?? 0}
                                  </p>
                                </div>
                                <div className={`p-3 rounded-lg ${
                                  darkMode ? "bg-zinc-700" : "bg-gray-50"
                                }`}>
                                  <div className="flex items-center gap-2">
                                    <Clock className={`h-4 w-4 ${
                                      darkMode ? "text-purple-400" : "text-purple-500"
                                    }`} />
                                    <span className={`text-xs font-medium ${
                                      darkMode ? "text-gray-400" : "text-gray-500"
                                    }`}>
                                      Criado em
                                    </span>
                                  </div>
                                  <p className={`text-sm font-semibold mt-1 ${
                                    darkMode ? "text-white" : "text-gray-900"
                                  }`}>
                                    {new Date(fluxo.create_at).toLocaleDateString('pt-BR')}
                                  </p>
                                </div>
                              </div>

                              {/* Toggle Padrão */}
                              <div className={`flex items-center justify-between p-4 rounded-lg mb-4 ${
                                darkMode ? "bg-zinc-700/50" : "bg-gray-50"
                              }`}>
                                <div>
                                  <p className={`text-sm font-semibold ${
                                    darkMode ? "text-white" : "text-gray-900"
                                  }`}>
                                    Definir como Padrão
                                  </p>
                                  <p className={`text-xs ${
                                    darkMode ? "text-gray-400" : "text-gray-500"
                                  }`}>
                                    Usado automaticamente nas conversas
                                  </p>
                                </div>
                                <button
                                  onClick={() => {
                                    setShowPadraoModal(true);
                                    setSelectedFluxo(fluxo);
                                  }}
                                  className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors ${
                                    fluxo.padrao
                                      ? "bg-green-500"
                                      : darkMode
                                      ? "bg-gray-600"
                                      : "bg-gray-300"
                                  }`}
                                >
                                  <span
                                    className={`inline-block h-5 w-5 transform rounded-full bg-white shadow-lg transition-transform ${
                                      fluxo.padrao ? "translate-x-6" : "translate-x-1"
                                    }`}
                                  />
                                </button>
                              </div>

                              {/* Ações */}
                              <div className="grid grid-cols-4 gap-2">
                                <button
                                  onClick={() => handlePreviewFluxo(fluxo)}
                                  className={`flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
                                    darkMode 
                                      ? "bg-zinc-700 hover:bg-zinc-600 text-white" 
                                      : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                                  }`}
                                >
                                  <Eye className="h-4 w-4" />
                                  Ver
                                </button>
                                <button
                                  onClick={() => handleEditFluxo(fluxo)}
                                  disabled={carregandoFluxo === fluxo.id}
                                  className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium bg-blue-500 hover:bg-blue-600 text-white transition-all"
                                >
                                  <Edit className="h-4 w-4" />
                                  Editar
                                </button>
                                <button
                                  onClick={async () => {
                                    try {
                                      await fluxosAPI.duplicar(fluxo.id);
                                      toast.success(`Fluxo "${fluxo.nome}" duplicado!`);
                                      loadFluxos();
                                    } catch (e) { toast.error('Erro ao duplicar'); }
                                  }}
                                  className={`flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all ${
                                    darkMode
                                      ? "bg-zinc-700 hover:bg-zinc-600 text-white"
                                      : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                                  }`}
                                >
                                  <Copy className="h-4 w-4" />
                                  Duplicar
                                </button>
                                <button
                                  onClick={() => handleDelete(fluxo.id)}
                                  className="flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium bg-red-500 hover:bg-red-600 text-white transition-all"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>

                {/* Paginação — no padrão de Contatos: só aparece com mais de uma página */}
                {fluxoTotalPaginas > 1 && (
                  <div className={`flex items-center justify-between mt-4 px-4 py-3 rounded-xl ${
                    darkMode ? 'bg-zinc-800 border border-zinc-700' : 'bg-white border border-gray-200'
                  }`}>
                    <span className={`text-xs ${textS}`}>
                      Página {fluxoPagina} de {fluxoTotalPaginas}
                    </span>
                    <div className="flex gap-2">
                      <button
                        onClick={() => setFluxoPagina((p) => Math.max(1, p - 1))}
                        disabled={fluxoPagina <= 1}
                        className={`px-3 py-1.5 text-sm rounded-lg disabled:opacity-40 ${
                          darkMode ? 'bg-zinc-700 text-gray-300 hover:bg-zinc-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                      >
                        Anterior
                      </button>
                      <button
                        onClick={() => setFluxoPagina((p) => Math.min(fluxoTotalPaginas, p + 1))}
                        disabled={fluxoPagina >= fluxoTotalPaginas}
                        className={`px-3 py-1.5 text-sm rounded-lg disabled:opacity-40 ${
                          darkMode ? 'bg-zinc-700 text-gray-300 hover:bg-zinc-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                        }`}
                      >
                        Próxima
                      </button>
                    </div>
                  </div>
                )}
            </div>
        )}

        {showDeleteModal && (
          <div
            className="modal-overlay"
            onClick={() => setShowDeleteModal(false)}
          >
            <div
              className={`modal-container max-w-md ${darkMode ? "bg-zinc-800" : "bg-white"}`}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="modal-header">
                <h3 className={`modal-title ${darkMode ? "text-red-400" : "text-red-600"}`}>
                  Confirmar Exclusão
                </h3>
                <button
                  type="button"
                  onClick={() => {
                    setShowDeleteModal(false);

                  }}
                  className={`modal-close-button ${darkMode ? "text-white" : "text-gray-900"}`}
                >
                  ×
                </button>
              </div>

              {/* Body */}
              <div className="modal-body">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="flex-shrink-0">
                    <svg
                      className="w-10 h-10 text-red-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.35 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                  </div>
                  <div>
                    <h4 className={`text-lg font-medium ${darkMode ? "text-white" : "text-gray-900"}`}>
                      Tem certeza que deseja excluir este contato?
                    </h4>
                    <p className={`text-sm mt-1 ${darkMode ? "text-gray-400" : "text-gray-600"}`}>
                      Esta ação não pode ser desfeita.
                    </p>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => {
                    setShowDeleteModal(false);
                  
                  }}
                  className={`modal-button modal-button-secondary ${
                    darkMode
                      ? "border-gray-600 text-white hover:bg-zinc-700"
                      : "border-gray-300 text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleModalDelete}
                  className="modal-button bg-red-600 hover:bg-red-700 text-white"
                >
                  Excluir
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Modal Confirmar Fluxo Padrão */}
        {showPadraoModal && selectedFluxo && (
          <div
            className="modal-overlay"
            onClick={() => setShowPadraoModal(false)}
          >
            <div
              className={`modal-container max-w-md ${darkMode ? "bg-zinc-800" : "bg-white"}`}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <h3 className={`modal-title ${darkMode ? "text-white" : "text-gray-900"}`}>
                  {selectedFluxo.padrao ? "Desmarcar Fluxo Padrão" : "Definir Fluxo Padrão"}
                </h3>
                <button
                  type="button"
                  onClick={() => setShowPadraoModal(false)}
                  className={`modal-close-button ${darkMode ? "text-white" : "text-gray-900"}`}
                >
                  ×
                </button>
              </div>

              <div className="modal-body">
                <div className="flex items-start space-x-3">
                  <div className="flex-shrink-0">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                      selectedFluxo.padrao ? "bg-yellow-100" : "bg-green-100"
                    }`}>
                      <Bot className={`h-5 w-5 ${
                        selectedFluxo.padrao ? "text-yellow-600" : "text-green-600"
                      }`} />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h4 className={`text-lg font-medium ${darkMode ? "text-white" : "text-gray-900"}`}>
                      {selectedFluxo.padrao 
                        ? "Desmarcar como padrão?" 
                        : `Definir "${selectedFluxo.nome}" como fluxo padrão?`
                      }
                    </h4>
                    <p className={`text-sm mt-2 ${darkMode ? "text-gray-400" : "text-gray-600"}`}>
                      {selectedFluxo.padrao 
                        ? "Este fluxo não será mais usado automaticamente nas conversas."
                        : "Este fluxo será usado automaticamente quando um contato iniciar uma conversa. O fluxo padrão anterior será desmarcado."
                      }
                    </p>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  onClick={() => setShowPadraoModal(false)}
                  className={`modal-button modal-button-secondary ${
                    darkMode
                      ? "border-gray-600 text-white hover:bg-zinc-700"
                      : "border-gray-300 text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  onClick={handleTogglePadrao}
                  className={`modal-button ${
                    selectedFluxo.padrao
                      ? "bg-yellow-600 hover:bg-yellow-700"
                      : "bg-green-600 hover:bg-green-700"
                  } text-white`}
                >
                  {selectedFluxo.padrao ? "Desmarcar" : "Definir como Padrão"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Fluxo Modal */}
        {showFluxoModal && (
          <FluxoVisualEditor
            fluxo={editingFluxo}
            clienteId={user?.cliente_id}
            onSave={handleFluxoSave}
            onCancel={() => {
              setShowFluxoModal(false);
              setEditingFluxo(null);
            }}
          />
        )}

        {/* Preview Modal */}
        {showPreview && previewFluxo && (
          <WhatsAppSimulator
            fluxo={previewFluxo}
            onClose={() => {
              setShowPreview(false);
              setPreviewFluxo(null);
            }}
          />
        )}
      </div>
    </Layout>
  );
};

export default AppConfig;
